
<div id="EmailUnsubscribePage">

    <div class="unsubscribe-page">  
        <div class="p-grid">

            <div class="p-col-12 header-image" *ngIf="configDto?.headerImageUrl !== null">
                <img [src]="configDto?.headerImageUrl" width="380" style="border-radius: 12px;">
            </div>
            
            <div class="p-col-12 row-position" *ngIf="configDto?.openingIntroductionText !== null">
                {{configDto?.openingIntroductionText}}
            </div>

            <div class="p-col-12 checkbox-notice" *ngIf="configDto?.noteCheckbox1 !== null">
                <label>
                    <i class="pi pi-check-square"></i>
                    <span class="checkbox-label-pad" [innerHTML]="configDto?.noteCheckbox1"></span>
                </label>
            </div>

            <div class="p-col-12 checkbox-notice" *ngIf="configDto?.noteCheckbox2 !== null">
                <label>
                    <i class="pi pi-stop"></i>
                    <span class="checkbox-label-pad" [innerHTML]="configDto?.noteCheckbox2"></span>
                </label>
            </div>
    
            <div class="p-col-12 row-position email-address-style" *ngIf="configDto?.emailAddressText !== null">
                {{configDto?.emailAddressText}}  <span class="member-email">{{emailAddress}}</span>
            </div>
    
            <div class="p-col-12 changes-notice" *ngIf="configDto?.preferencesIntroductionText !== null">
                {{configDto?.preferencesIntroductionText}}
            </div>

            <div *ngIf="!loading" style="width: 100%;">
                <!-- <div *ngIf="!configDto?.useGlobalUnsubscribeOnly" style="width: 100%; text-align: right; padding-right: .3em">
                    Unsubscribe?
                </div> -->
                
                <!-- <div *ngIf="!configDto?.useGlobalUnsubscribeOnly" class="p-col-12" style="padding-left: .4em; padding-right: .4em">
                    <table class="unsubscribe-table">
                        <tr *ngFor="let group of unsubscribeGroups" style="width: 100%">
                            <td class="unsubscribe-name-td">{{group.unsubscribeGroupName}}</td>
                            <td class="unsubscribe-buttons-td">
                                <span style="float: right;">
                                    <p-selectButton [options]="unsubscribeOptions" [(ngModel)]="group.selected" (onChange)="updateGlobalSelection($event)" [id]="group.id"></p-selectButton>
                                </span>
                            </td>
                        </tr>
                    </table>                    
                </div> -->
                
                <div class="p-col-12 row-position" *ngIf="configDto?.globalUnsubscribeText !== null">
                    <p-checkbox id="UnsubscribeAll" name="UnsubscribeAll" binary="true" class="fix-chkbox"
                        [(ngModel)]="unsubscribeAll" [label]="configDto?.globalUnsubscribeText"
                        (onChange)="updateSelections($event)">
                    </p-checkbox>
                </div>
            </div>
        </div>
        
        <div *ngIf="errorString !== null && errorString !== undefined && errorString.trim() !== ''" class="error-message">
            {{errorString}}
        </div>

        <div class="unsubscribe-buttons" style="margin-bottom: 2em" *ngIf="configDto?.saveButtonText !== null">
            <div *ngIf="saveCalled" class="save-progress">{{configDto?.saveProgressText}}</div>
            <button pButton type="button" [disabled]="isSaveBtnClicked" *ngIf="!saveCalled" (click)="save()" id="saveUnsubscribePreferences" color="primary" [label]="configDto?.saveButtonText" ></button>
        </div>
    </div>
</div>
